"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoLayer = getVideoLayer;
exports.getCaptionLayer = getCaptionLayer;
exports.getVideoScript = getVideoScript;
exports.getCreationTimeEstimate = getCreationTimeEstimate;
exports.getPhotoLayer = getPhotoLayer;

var _promoAnimation = require("promo-animation");

var _captionUtils = require("./caption-utils");

var _clipUtils = require("./clip-utils");

var _photoUtils = require("./photo-utils");

function getVideoScriptTiming(timeline) {
  return {
    start: {
      timestamp: timeline.start.timestamp,
      transition: timeline.start.transition,
      fadeDuration: timeline.start.transitionDuration
    },
    end: {
      timestamp: timeline.end.timestamp,
      transition: timeline.end.transition,
      fadeDuration: timeline.end.transitionDuration
    }
  };
} // video layer A.K.A layer_0


function getVideoLayer(clips) {
  const videoLayer = [];
  clips.forEach(clip => {
    const {
      timeline,
      type,
      video,
      crop,
      start
    } = clip;

    if (type !== _clipUtils.CLIP_TYPE.PHOTO) {
      const videoExtends = {
        type: 1,
        // video Type
        videoId: video.videoId,
        isUpload: video.isUpload,
        croppedVideo: crop,
        offset: start // clip trim offset

      };
      videoLayer.push({ ...getVideoScriptTiming(timeline),
        ...videoExtends
      });
    }
  });
  return videoLayer;
} // captions A.K.A layer_1


function getCaptionLayer(captions) {
  return captions.map(caption => {
    const textStyleTemplate = (0, _captionUtils.getFirstItemByLayout)(caption.children, 'lottie');
    const {
      timing
    } = caption;
    const inDuration = textStyleTemplate.data.inDuration / 1000; // set to seconds

    const outDuration = textStyleTemplate.data.outDuration / 1000; // set to seconds

    const layout = textStyleTemplate.layout;
    const animationId = textStyleTemplate.data.id;
    const outTransition = (0, _captionUtils.isOutro)(caption) ? 'cut' : 'fade';
    const captionScriptTiming = {
      animationId,
      animationType: layout,
      type: 5,
      // Animation Type
      start: {
        timestamp: parseFloat((timing.start + inDuration).toFixed(2)),
        // Remove the fadeDuration and inDuration
        fadeDuration: inDuration,
        transition: 'fade'
      },
      end: {
        timestamp: parseFloat((timing.end - outDuration).toFixed(2)),
        fadeDuration: outDuration,
        transition: outTransition
      }
    };
    return captionScriptTiming;
  });
} // video layer A.K.A layer_photos


function getPhotoLayer(clips) {
  const photoLayer = [];
  clips.forEach(clip => {
    const {
      timeline,
      type,
      photo,
      crop,
      animation
    } = clip;

    if (type === _clipUtils.CLIP_TYPE.PHOTO) {
      const photoExtends = {
        type: 6,
        // photo Type
        animationType: 'lottiephoto',
        crop,
        photoId: photo.id,
        photoSource: photo.source,
        animation,
        images: (0, _photoUtils.getPhotoClipImages)(clip, _promoAnimation.BlurImage, _promoAnimation.CropImage)
      };
      photoLayer.push({ ...getVideoScriptTiming(timeline),
        ...photoExtends
      });
    }
  });
  return photoLayer;
}

function getVideoScript(videoData) {
  return {
    layer_0: getVideoLayer(videoData.clips),
    layer_1: getCaptionLayer(videoData.decoration.decorationData),
    layer_photos: getPhotoLayer(videoData.clips)
  };
}

function getCreationTimeEstimate(videoData) {
  // when we support photo we will have to calc the values
  const duration = videoData.duration;
  const photoTotalDuration = 0;
  const photoCreationTime = 0;
  const clacCreationTime = (0.32 * (duration - photoTotalDuration) + 8 + photoCreationTime) * 1.1;
  return Math.round(clacCreationTime);
}